export default "__VITE_ASSET__Bv0D3E49__"